import axios from 'axios';
import { APP, STORAGE } from '@/shared/config';

class CommonApi {
  getLanguages() {
    const result = [
      {
        key: 'en',
        label: 'English',
      },
      {
        key: 'ru',
        label: 'Русский',
      },
    ];
    return result;
  }

  getUserLanguage() {
    const language =
      localStorage.getItem(STORAGE.LANGUAGE) ?? APP.DEFAULT_LANGUAGE;
    return { language };
  }

  setUserLanguage(payload) {
    localStorage.setItem(STORAGE.LANGUAGE, payload?.language);
  }

  // TODO: уточнить требования
  async getLatLng(payload) {
    return await axios.get(
      `https://nominatim.openstreetmap.org/search?q=${
        payload.search ?? ''
      }&format=json&limit=1`,
    );
  }

  // TODO: уточнить требования
  async getAddress(payload) {
    return await axios.get(
      `https://nominatim.openstreetmap.org/reverse/search?lat=${payload.lat}&lon=${payload.lon}&zoom=18&format=json&limit=1`,
    );
  }
}

export const commonApi = new CommonApi();